import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueResizeObserver from "vue-resize-observer";
import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import { getAccessToken } from "@/utils/auth";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  faFacebookSquare,
  faInstagram,
  faLine,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import {
  faKey,
  faUser,
  faChevronRight,
  faUserAlt,
  faMapSigns,
  faMapMarkerAlt,
  faSearch,
  faPrint,
  faCaretRight,
  faDownload,
  faArrowLeft,
  faTicketAlt,
  faQrcode
} from "@fortawesome/free-solid-svg-icons";
import VueAwesomeSwiper from "vue-awesome-swiper";
import {
  Swiper as SwiperClass,
  Pagination,
  Mousewheel,
  Autoplay,
} from "swiper/swiper.esm";
import getAwesomeSwiper from "vue-awesome-swiper/dist/exporter";
SwiperClass.use([Pagination, Mousewheel, Autoplay]);
Vue.use(getAwesomeSwiper(SwiperClass));
import "swiper/swiper-bundle.css";
import VueGtag from "vue-gtag";
Vue.use(VueResizeObserver);

Vue.use(
  VueGtag,
  {
    config: { id: "UA-147159731-1" },
  },
  router
);
import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_API_KEY,
    libraries: "places",
  },
  installComponents: true,
});

library.add(
  faInstagram,
  faFacebookSquare,
  faLine,
  faKey,
  faUser,
  faChevronRight,
  faUserAlt,
  faMapSigns,
  faMapMarkerAlt,
  faYoutube,
  faSearch,
  faPrint,
  faCaretRight,
  faDownload,
  faArrowLeft,
  faTicketAlt,
  faQrcode
);

Vue.use(VueAwesomeSwiper);
Vue.component("font-awesome-icon", FontAwesomeIcon); //使用kebab-case

Vue.config.productionTip = false;
Vue.use(BootstrapVue);

import VueFriendlyIframe from 'vue-friendly-iframe';
Vue.use(VueFriendlyIframe);

router.beforeEach(async (to, from, next) => {
  const hasToken = getAccessToken();
  if (hasToken) {
    try {
      await store.dispatch("user/getInfo");
      next();
    } catch (error) {
      store.dispatch("user/logout");
    }
  } else {
    next();
  }
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
